import { useTranslations } from "next-intl";
import S from "./index.module.scss";
import Image from "next/image";

const Team = () => {
  const t = useTranslations("about.team");

  return (
    <div className={S.wrapper}>
      <Image src="/images/about/team/background.png" alt="Team" width={800} height={900} />

      <div className={S.textWrapper}>
        <p className={S.description}>{t("thriving")}</p>
        <h2 className={S.title}>
          {t("ambitions")} <span> {t("professionals")}. </span>
        </h2>
      </div>
    </div>
  );
};

export default Team;
